import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCampaign } from 'api/campaigns';
import * as Dialog from 'components/dialog';
import { Iframe } from 'components/iframe';
import { campaignQueryKeys } from 'queries/campaign-query-keys';

interface CreateTransactionDialogProps extends Dialog.DialogProps {
    campaignId: number;
}

const CreateTransactionDialog = (props: CreateTransactionDialogProps) => {
    const { campaignId, children, ...rest } = props;

    const { data } = useSuspenseQuery({
        queryKey: campaignQueryKeys.campaign(campaignId),
        queryFn: () => fetchCampaign({ campaignId }),
    });
    const url = data?.embed_url;

    if (!url) {
        return null;
    }

    return (
        <Dialog.Root {...rest}>
            {children}
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content className={'max-w-[600px]'}>
                    <Dialog.Body>
                        <Dialog.Header>
                            <Dialog.Title>Create Transaction</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Description className={'relative h-[600px] w-full'}>
                            <Iframe
                                className={'absolute inset-0 !w-full'}
                                url={`${url}?type=dashboard`}
                            />
                        </Dialog.Description>
                    </Dialog.Body>
                    <Dialog.Close />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export { CreateTransactionDialog };
